import { Linking } from 'react-native';
import Logger, { LoggingModule } from './Logger';

// Intermountain Health App Google Play Store URL
const MHP_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=org.ihc.dfd&hl=en_US';
// Intermountain Health App Apple App Store URL
const MHP_APP_STORE_URL = 'https://apps.apple.com/us/app/my-health-by-intermountain/id1454432442';

/**
 * Given a phone number, will open the devices phone app in order to call the number
 */
async function callPhoneNumber(phone: string) {
  try {
    window.location.href = `tel: ${phone}`;
    return true;
  } catch (err) {
    Logger.error(`${LoggingModule.linkingServices}Failed to call phone number`, err);
    return null;
  }
}

/**
 * Attempts to open open the Intermountain Health App app's web page.
 * @param isApple {boolean} pass true if the user is on an Apple device, else false.
 * @returns {Promise<void>}
 */
function openAppPage(isApple: boolean): Promise<void> {
  const targetURL = isApple ? MHP_APP_STORE_URL : MHP_PLAY_STORE_URL;
  return Linking.openURL(targetURL);
}

const LinkingServices = {
  openAppPage,
  callPhoneNumber
};

export default LinkingServices;
